import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/menu-catalog/components/MenuCatalogInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/NavigationBar.tsx");
